export default {
  'exception-500.exception.back': 'Back to home',
  'exception-500.description.500': 'Sorry, the server is reporting an error',
};
